import PropTypes from 'prop-types';

import themes from '../utils/iconColorThemes';

const ClipboardIcon = ({ theme = 'base' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="26"
    viewBox="0 0 23 26"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill={themes[theme]}
        d="M21.2 0H6.6C5.6 0 5 .6 5 1.6v18.2c0 .8.8 1.6 1.6 1.6H21.2c.8 0 1.6-.8 1.6-1.6V1.6c0-1-.8-1.6-1.6-1.6z"
      />
      <path
        fill="white"
        d="M21.4 19.2c0 .4-.4.6-.6.6H7c-.4 0-.6-.4-.6-.6v-17c0-.4.4-.6.6-.6h13.6c.4 0 .6.4.6.6v17h.2z"
      />
      <g>
        <path
          fill={themes[theme]}
          d="M16.6 4.4H2C1.2 4.4.4 5.2.4 6v18.2c0 .8.8 1.6 1.6 1.6H16.6c.8 0 1.6-.8 1.6-1.6V6c0-.8-.6-1.6-1.6-1.6z"
        />
        <path
          fill="white"
          d="M16.8 23.8c0 .4-.4.6-.6.6H2.4c-.4 0-.6-.4-.6-.6v-17c0-.4.4-.6.6-.6H16c.4 0 .6.4.6.6v17h.2z"
        />
      </g>
      <g fill={themes[theme]}>
        <path d="M10 14.2c0-.2 0-.2 0 0 0-.2 0-.2 0 0 0-.2 0-.2 0 0-.2-.2-.2-.2 0 0l-.2-.2s-.2 0-.2-.2h-.2c-.8-.2-1.6-.2-2.2.2l-.2.2-1.4 1.4c-1 1-1 2.4 0 3.4S8 20 9 19l1.4-1.4.2-.2c-.4.2-1 0-1.4 0L8 18.6c-.6.6-1.4.6-1.8 0-.6-.6-.6-1.4 0-1.8l1.2-1.2.4-.4c.4-.4 1-.4 1.4-.4.2 0 .6 0 .8-.2l.2-.2v-.2s0-.2-.2-.2c.2.4.2.2 0 .2z" />
        <path d="M9.6 11.4l-1.4 1.4-.2.2c.4-.2 1 0 1.4 0l1.2-1.2c.6-.6 1.4-.6 1.8 0 .6.6.6 1.4 0 1.8L11 15.2l-.4.4c-.4.4-1 .4-1.4.4-.2 0-.6 0-.8.2l-.2.2v.2s0 .2.2.2l.2.2.2.2s.2 0 .2.2h.2c.8.2 1.6.2 2.2-.2l.2-.2 1.4-1.4c1-1 1-2.4 0-3.4-1-1.8-2.4-1.8-3.4-.8z" />
      </g>
    </g>
  </svg>
);

ClipboardIcon.propTypes = {
  theme: PropTypes.oneOf(Object.keys(themes))
};

export default ClipboardIcon;
